import { UserRolesService } from './../../services/user.roles.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WindowBase } from '../../services/window-dialogs/window.base';

// @ANGULAR
import { ActivatedRoute, UrlSegment } from '@angular/router';

// MODELS
import { TicketMessageItem } from '../../models/domain/ticket.message.item';
import { Note, NoteTypes } from '../../models/domain/note';
import { KeyValuePair } from '../../models/KeyValuePair';
import { PinAddRequest } from '../../models/ss-api/requests/pin.add.request';
import { PinTypes } from '../../models/domain/pin';
import { MemberDashboard } from '../../models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../../models/ss-api/responses/templates.and.from.response';
import { TicketStatusTypes, TicketUrgencyTypes, CustomTicketItem } from '../../models/domain/custom.ticket.item';

// SERVICES
import { ssApiService } from '../../services/ss-api.service';
import { AdminHistoryService } from '../../services/admin.history.service';
import { AdminPresenceService } from '../../services/admin.presence.service'; // WAS ../../../../services/admin.presence.service
import { TicketService } from '../../services/ticket.service'; // WAS ../../../../services/ticket.service
import { GlobalService } from '../../services/global.service';
import { PinService } from '../../services/pin.service';

// MANAGERS
import { EntityChangedArgs } from '../../managers/manager.base';
import { NoteManagerConstructor } from '../../managers/note.manager';
import { NoteManager } from '../../managers/note.manager';
import { TicketItem } from '../../models/domain/ticket.item'; // WAS managers/ticket.manager
import { TicketManager } from '../../managers/ticket.manager';

// COMPONENTS
import { CKEditorComponent } from 'ng2-ckeditor';
import { NoteDetailsFullComponent } from '../../../app/dialogs/note.details/components/note.details.full/note.details.full.component';
import { Subscription } from 'rxjs';
import { TemplateSelectionComponent } from '../../shared/components/template.selection/template.selection.component';

// OTHER
import { DialogComponent, DialogService } from "../../services/modal-dialogs";
import { Title } from '@angular/platform-browser';
import { SelectItem } from 'primeng/primeng';
import { TicketAssignAdminRequest } from '../../models/ss-api/requests/ticket.assign.admin.request';
import { AddCustomTicketReplyRequest } from '../../models/ss-api/requests/add.custom.ticket.reply.request';
import { EditCustomTicketRequest } from '../../models/ss-api/requests/edit.custom.ticket.request';
import { TicketAssignMemberRequest } from '../../models/ss-api/requests/ticket.assign.member.request';
import { WindowEvent, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';
import { SweetAlertService } from "ng2-cli-sweetalert2";

export enum TicketWindowTypes {
  Internal = 0,
  Member = 1,
}

export class TicketWindowData {
  TicketWindowType : TicketWindowTypes;
  TicketID : number;
  MemberID : number;
}

@Component({
  selector: 'ticket-window',
  styleUrls: ['./ticket.window.scss'],
  templateUrl: './ticket.window.html'
})
export class TicketWindow extends WindowBase<TicketWindowData> implements OnDestroy {

  TicketWindowType : TicketWindowTypes = TicketWindowTypes.Internal;

  ticketManager: TicketManager;
  TicketID : number;
  Ticket: CustomTicketItem = new CustomTicketItem;

  TicketReplyLogArray: Array<any> = new Array<any>();
  
  isChanged : boolean = false;

  IsBusy : boolean = false;
  ChatIsBusy : boolean = false;
  SendEmail : boolean = true;

  AddReply : boolean = false;

  //browser Title
  private originalTitle: string;
  //subscriptions
  private ticketOnMemberAssign: Subscription;
  private ticketOnMemberUnassign: Subscription;


  // EMAIL TEMPLATE STUFF
  MemberData: MemberDashboard = new MemberDashboard();
  TemplatesAndFrom: TemplatesAndFromResponse = new TemplatesAndFromResponse;
  emailTemplate : string = "";
  emailTemplatePanel : boolean = false;

  TicketReplyMessage : string;

  // CHAT SCROLL WINDOW
  @ViewChild('chatWindow') private chatScrollWindow: ElementRef;
  @ViewChild('chatScrollContent') private chatScrollContent: ElementRef;
  
  @ViewChild('CKEDITOR') private CKEDITOR: ElementRef;


  MemberID : number = 0;
  TicketMemberID : number;

  user: SelectItem[];
  selectedUser: number;

  status: SelectItem[];
  selectedStatus: number;


  disableScrollDown = false

  MemberOptions : SelectItem[];
  SelectedMemberID : number = 0;

  UserOptions: SelectItem[];
  SelectedUser: number;

  StatusOptions: SelectItem[];

  UrgencyOptions : SelectItem[];
  SelectedUrgency : number;

  DueDate : Date;

  IsInternal : boolean;

  // EDIT FILED VARIABLES
  editAdminID : boolean = false;
  oldAdminID : number;
  editStatus : boolean = false;
  oldStatus : TicketStatusTypes;
  editMemberID : boolean = false;
  oldMemberID : number;
  editPriority : boolean = false;
  oldPriority : TicketUrgencyTypes;
  editInternal : boolean = false;
  oldInternal : boolean = false;
  editDueDate : boolean = false;
  oldDueDate : Date;

  // CKEditor Config
  private CKEditorConfig = {
    allowedContent: true,
    resize_enabled: false,
    height: '100%',
    toolbarLocation: 'bottom'
  }

  constructor(dialogService: DialogService,
    private pinService: PinService,
    private api: ssApiService,
    public gb: GlobalService,
    private adminPresence: AdminPresenceService,
    private ticketService: TicketService,
    public historyService: AdminHistoryService,
    private activeRoute: ActivatedRoute,
    private changeDetect: ChangeDetectorRef,
    private titleService: Title,
    public roles: UserRolesService,
    private sweetAlert: SweetAlertService)
    {
      super();
    }




  ngOnDestroy() {
    //this.titleService.setTitle(this.originalTitle);
  }


  async Init() {
    
    this.TicketID = this.Context.Data.TicketID;
    this.TicketWindowType = this.Context.Data.TicketWindowType;
    this.MemberID = this.Context.Data.MemberID;

    this.IsBusy = true;

    this.TicketReplyLogArray = new Array<any>();

    await this.GetTicket();
    await this.InitStatus();
    await this.InitMemberOptions();
    await this.InitUserOptions();
    await this.InitUrgencyOptions();
    this.DueDate = this.Ticket.DueDate;
    this.IsInternal = this.Ticket.IsInternal;
    //this.Ticket.DateTimeCreated


    this.changeDetect.detectChanges();
    //this.scrollChatToBottom();
    this.IsBusy = false;

    this.SetWindowTitle();

    this.GetTicketLogs();

  }


  Close() {
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Close, true));
    window.close();
  }


  SetWindowTitle() {

    let newWindowTitle : string ="";

    if( this.TicketWindowType == TicketWindowTypes.Internal )
      newWindowTitle += "Internal";
    else
      newWindowTitle += "Support";

    newWindowTitle += " Ticket | ID: " + this.Ticket.TicketID + " | subject: " + this.Ticket.Subject + " | member: " + this.Ticket.MemberName;

    this.titleService.setTitle( newWindowTitle );

  }

  async GetTicket() {

    //console.log("Getting Ticket", this.TicketID);

    let response = await this.api.GetTicketByID( Number(this.TicketID) ).toPromise();
    if(response.Result) {

        console.log("Got our TICKET! ", response.Data);
        this.Ticket = response.Data;
        console.log("REPLIES: ", this.Ticket.Replies);

        if(this.Ticket.Replies) {
          this.Ticket.Replies.forEach((reply) => {
            this.TicketReplyLogArray.push(reply);
          })
        }

    } else {
      console.log("Error", response.Message);
    }

  }

  GetTicketLogs() {
    let disposable = this.api.AdminLogsByTicketID(Number(this.TicketID)).subscribe((response) => {
      console.log("TICKET LOGS: ", response.Data);
      response.Data.shift();
      if(response.Data.length > 0) {
        response.Data.forEach((log) => {
          this.TicketReplyLogArray.push(log);
        })
      }
      disposable.unsubscribe();
    })
  }

  SortLogsByDate() {
    if(this.TicketReplyLogArray.length > 0) {
      this.TicketReplyLogArray.sort((left, right) => {
        if(left.DateTimeCreated > right.DateTimeCreated) {
          return 1;
        } else {
          return -1;
        }
      })
  
      console.log(this.TicketReplyLogArray);

      return this.TicketReplyLogArray;
    }
  }

  originalMessageClass() : string {
    let myClasses : string = ""

    if( this.Ticket ) {
      if( !this.Ticket.CreatedByAdmin )
        myClasses += "member";
      else if ( this.Ticket.CreatedByAdmin )
        if( this.Ticket.OriginalAdminID == this.gb.AdminId )
          myClasses += "me"
        else
          myClasses += "admin"       
    }

    return myClasses;
  }

  private async InitStatus() {
    this.StatusOptions = [];

    this.StatusOptions.push({ label: "New", value: TicketStatusTypes.New  });
    this.StatusOptions.push({ label: "In Progress", value: TicketStatusTypes.InProgress  });
    
    this.StatusOptions.push({ label: "Awaiting Member", value: TicketStatusTypes.AwaitingMemberResponse  });
    this.StatusOptions.push({ label: "Awaiting Admin", value: TicketStatusTypes.AwaitingAdminResponse });

    this.StatusOptions.push({ label: "TOS", value: TicketStatusTypes.TOS });
    
    this.StatusOptions.push({ label: "Closed", value: TicketStatusTypes.Closed  });

    this.selectedStatus = this.Ticket.Status;

  }

  async InitUserOptions() {
    this.UserOptions = [];

    // this.UserOptions.push( { label: "Not Assigned", value: 0 } );
    // this.UserOptions.push( { label: "Me - " + this.gb.FullName, value: this.gb.AdminId } );


    if(this.gb.AllAdmins) {
      this.gb.AllAdmins.forEach( x => {
        if( x.AdminID == this.gb.AdminId || x.FirstName == "API" )
          return;
          if( !x.FirstName.toLowerCase().includes('backend') )
            this.UserOptions.push( { label: x.FirstName + " " + x.LastName, value : x.AdminID } );
      });
    }

    this.UserOptions.sort((left, right) => {
      if(left.label > right.label) {
        return 1;
      } else {
        return -1;
      }
    })
    
    this.UserOptions.unshift({ label: "Me - " + this.gb.FullName, value: this.gb.AdminId });
    this.UserOptions.unshift({ label: "Don't Assign", value: 0 });

    if(this.gb.AllAdmins) {
      this.gb.AllAdmins.forEach( x => {
        if( x.AdminID == this.gb.AdminId || x.FirstName == "API" )
          return;
          if( x.FirstName.toLowerCase().includes('backend') )
            this.UserOptions.push( { label: x.FirstName + " " + x.LastName, value : x.AdminID } );
      });
    }

    this.SelectedUser = this.Ticket.AdminID;
    
    console.log("ALL MY ADMINS!#$", this.gb.AllAdmins);
    console.log("Options: " + this.UserOptions);
    console.log("Selected User: " + this.selectedUser);
  }


  async InitMemberOptions() {
    this.historyService.Refresh();
    //console.log("History", this.historyService.History);
    this.MemberOptions = [];
    this.MemberOptions.push( { label: "None", value : 0 } );
    this.MemberOptions.push( { label: this.Ticket.MemberName, value : this.Ticket.MemberID } );

    this.historyService.History.forEach( x => {
      if( x.MemberID != null && x.MemberID != undefined ) {
        this.MemberOptions.push( { label : x.MemberName, value : x.MemberID } );
      }
    });
    
    this.SelectedMemberID = this.Ticket.MemberID;

  }

  MemberSelectChanged() {
    //console.log( "Selected Member ID: " + this.SelectedMemberID );
    if( this.SelectedMemberID == -1 )
      this.SendEmail = false;       
  }

  async InitUrgencyOptions() {
    this.UrgencyOptions = [];
    this.UrgencyOptions.push( { label : "Low",      value : TicketUrgencyTypes.Low } );
    this.UrgencyOptions.push( { label : "Normal",   value : TicketUrgencyTypes.Normal } );
    this.UrgencyOptions.push( { label : "High",     value : TicketUrgencyTypes.High } );
    this.UrgencyOptions.push( { label : "Super High", value : TicketUrgencyTypes.SuperHigh } );
    this.SelectedUrgency = this.Ticket.Urgency;
  }

  confirm() {

    this.closeOK();

  }


  closeOK() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    this.Close();

  }

  showEmailTemplatePanel() {
    this.emailTemplatePanel = true;
  }

  updateEmailTemplate( newTemplate : string ) {
    this.emailTemplate = newTemplate;
    this.TicketReplyMessage = newTemplate;
    this.emailTemplatePanel = false;
  }

  updateEmailAddress( e : any ) {
    console.log("Update Email Address : ", e);
  }
  updateSubject ( e : any ) {
    console.log("Update Subject : ", e);
  }

  cancelEmailTemplate() {
    this.emailTemplatePanel = false;
  }

  scrollChatToBottom(): void {
    try {
      console.log( "Scroll Height", this.chatScrollWindow.nativeElement.scrollHeight );
      this.chatScrollWindow.nativeElement.scrollTop = this.chatScrollWindow.nativeElement.scrollHeight;
      console.log( "Scroll to Top = ", this.chatScrollWindow.nativeElement.scrollTop)
    } catch (err) {
      console.log(err);
    }
  }

  scrollChatToTop(): void {
    try {
      this.chatScrollWindow.nativeElement.scrollTop = 0;
    } catch (err) {
      console.log(err);
    }
  }

  async showSelectEmailTemplate( e : any ) {
    this.IsBusy = true;

    if( this.SelectedMemberID != undefined && this.SelectedMemberID != 0) {
      console.log("showSelectEmailTemplate selectedMemberID = ", this.SelectedMemberID);
      await this.api.getMemberDashboard( this.SelectedMemberID ).toPromise().then( response => {
          //console.log("data received from my new promise!", response);
          this.MemberData = response.Data;
        }, error => {
          console.log(error);
        });

    }
    
    
    if( this.isTemplatesEmpty() ) {
      let response = await this.api.GetEmailTemplatesBasicsAndFrom().toPromise();
      if(response.Result) {
          this.TemplatesAndFrom = response.Data;        
      } else {
        console.log("Error", response.Message);
      }
    }
    
    this.IsBusy = false;

    this.emailTemplatePanel = true;
    this.changeDetect.detectChanges();
  }

  isTemplatesEmpty() : boolean {
    if( this.TemplatesAndFrom == null || this.TemplatesAndFrom == undefined )
      return true;
    else if(this.TemplatesAndFrom.Templates == null || this.TemplatesAndFrom.Templates == undefined || this.TemplatesAndFrom.Templates.length == 0 )
      return true;
    else
      return false;
  }


  RemovePin() {
    //this.pinService.DeletePinByType(this.Ticket.TicketID, PinTypes.Ticket);
    this.changeDetect.detectChanges();
  }

  IsPinned(): boolean {
    //return this.pinService.IsPinned(this.Ticket.TicketID, PinTypes.Ticket);
    return true;
  }

  AddPin() {
    let request = new PinAddRequest();
    request.AdminID = this.gb.AdminId;
    request.PinType = PinTypes.Ticket;
    request.RelationID = this.Ticket.TicketID;
    this.pinService.Add(request);
  }
  
  SaveSettings() {
    console.log("Save Settings! YAY!");
  }



  isMin : boolean = true;
  isMax : boolean = false;

  minimizeEditor() {
    if (this.isMin) {
      this.isMin = false;
    } else {
      this.isMin = true;
    }
    this.isMax = false;
    this.changeDetect.detectChanges();
    this.scrollChatToBottom();
  }


  maximizeEditor() {
    if (this.isMax) {
      this.isMax = false;
    } else {
      this.isMax = true;
    }
    this.isMin = false;
    this.changeDetect.detectChanges();
    this.scrollChatToBottom();
  }


  normalizeEditor() {
    if (this.isMin) {
      this.isMin = false;
      this.isMax = false;
      this.changeDetect.detectChanges();
      this.scrollChatToBottom();
    }
  }

  

  AdminChanged(e:any) {
    console.log("AdminChanged");
    this.SetAsChanged( true );
  }


  SetAsChanged( newStatus : boolean ) {
    this.isChanged = newStatus;
    console.log("isChanged = " + this.isChanged );
  }


  async SaveTicket() {
    
    this.IsBusy = true;

    let request = new EditCustomTicketRequest;
    
    // Ticket Values that may change ::
    request.AdminID = Number(this.SelectedUser); // Assigned To Field
    request.Status = this.selectedStatus;
    request.MemberID = this.Ticket.MemberID;
    request.Urgency = this.SelectedUrgency;    
    request.DueDate = this.DueDate;
    
    // Ticket Values that don't change ::
    request.Body = this.Ticket.Body;
    request.CreatedByAdmin = this.Ticket.CreatedByAdmin;
    request.FromEmail = this.gb.Email;
    request.IsHTMLBody = true;
    request.IsInternal = this.IsInternal;
    request.SendEmail = this.SendEmail;
    request.Subject = this.Ticket.Subject;
    request.TicketID = this.TicketID;
    
    console.log( "SaveTicket Request object", request );
    

    // Check to see if we need to update Admin On ticket
    if( this.oldAdminID != this.SelectedUser ) {
      
      let adminRequest = new TicketAssignAdminRequest;
      adminRequest.AdminID = Number(this.SelectedUser);
      adminRequest.TicketID = this.TicketID;

      console.log("adminRequest : ", adminRequest);

      let adminResponse = await this.api.CustomTicketAssignAdmin( adminRequest ).toPromise();
      if( adminResponse.Result ) {
        console.log("Ticket Reasigned to new Admin", adminResponse);
      } else {
        console.log("Error", adminResponse );
      }

    }


    // Check to see if we need to update the Member on the ticket
    if( this.oldMemberID != this.SelectedMemberID ) {
      
      let memberRequest = new TicketAssignMemberRequest;
      memberRequest.MemberID = Number(this.SelectedMemberID);
      memberRequest.TicketID = this.TicketID;
      
      console.log("memberRequest : ", memberRequest);

      let memberResponse = await this.api.CustomTicketAssignMember( memberRequest ).toPromise();
      if( memberResponse.Result ) {
        console.log("Ticket Reasigned to new Member", memberResponse);
      } else {
        console.log("Error", memberResponse );
      }
    }
    

    // Do API Request to Update Ticket
    let disposable = this.api.EditCustomTicket( request ).subscribe( result => {
      disposable.unsubscribe();
      console.log("SaveTicket() result : ", result);

      //await this.Init();
      this.Init();

      this.SetAsChanged( false );

      this.IsBusy = false;

    }, error => {
      disposable.unsubscribe();
      console.log("Save Ticket Error : ", error);

    });
    

  }



  async SendReply() {
    this.IsBusy = true;

    let request = new AddCustomTicketReplyRequest;
    request.AdminID = this.gb.AdminId;
    request.Body = this.TicketReplyMessage;
    request.CreatedByAdmin = true;
    request.DueDate = this.Ticket.DueDate;
    request.FromEmail = this.gb.Email;
    request.IsHTMLBody = true;
    request.IsInternal = this.IsInternal;
    request.MemberID = this.SelectedMemberID;
    request.SendEmail = this.SendEmail;
    request.Status = this.selectedStatus;
    request.Subject = this.Ticket.Subject;
    request.TicketID = this.TicketID;
    request.Urgency = this.SelectedUrgency;
    console.log("SendReply Request object:", request);
    let response = await this.api.AddCustomTicketReply( request ).toPromise();
    if(response.Result) {
        console.log("Ticket Reply Added", response);
        await this.Init();
    } else {
      console.log("Error", response.Message);
    }

    this.IsBusy = false;
    this.minimizeEditor();
    this.AddReply = false;
    this.changeDetect.detectChanges();
    this.scrollChatToBottom();
  }

  AddNewReply() {
    this.AddReply = true;
    this.normalizeEditor();
    //this.CKEDITOR.nativeElement.focus();
  }
  CKEDITORready(e:any) {
    console.log("CKEDITOR:", e);
    //e.editor.focusManager.hasFocus = true;
  }


  GoToMember() {
    console.log("Going to member with ID:", this.MemberID);
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.NavigateToMember, this.MemberID));
  }

  DeleteTicket() {
    this.sweetAlert.swal({
      type: 'warning',
      title: "Are You Sure?",
      text: "Deleting is permanent and cannot be reversed",
      showCancelButton: true,
      preConfirm : () => {
        let disposable = this.api.DeleteCustomTicket(this.TicketID).subscribe(response => {
          if(response.Result) {
            this.sweetAlert.swal({
              type: 'success',
              title: "Ticket Deleted",
              timer: 1500
            }).then( () => {
              this.closeOK();
            }, () => {
              this.closeOK();
            } )
            disposable.unsubscribe();
          } else {
            this.sweetAlert.swal({
              type: 'error',
              title: "Could Not Delete Ticket"
            }).then( () => {} )
          }
        })
      }
    })
  }

}